import type { components } from '@feedfm/clips-api-client';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { ClipList } from '../ClipList';
import './Collection.css';

interface CollectionProps {
  collection: components['schemas']['Collection'];
}

const Collection: React.FC<CollectionProps> = ({ collection }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Paper elevation={3} className="collection-paper">
      <Box
        className="collection-header"
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <Typography variant="h5" component="h3" className="collection-title">
          {collection.collectionName} (ID: {collection.collectionId})
        </Typography>
        <IconButton className="expand-button">
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={isExpanded}>
        <ClipList clips={collection.clips} showIds={true} />
      </Collapse>
    </Paper>
  );
};

export default Collection;
